const headerWrapper =
  document.querySelector(
    ".luxury-header-wrapper"
  );

if (headerWrapper) {

  window.addEventListener(
    "scroll",
    () => {

      const currentScroll =
        window.pageYOffset;

      if (currentScroll > 80) {

        headerWrapper.classList.add(
          "hide-announcement"
        );

      } else {

        headerWrapper.classList.remove(
          "hide-announcement"
        );

      }

    }
  );

}